import { graphql } from '@/gql';
import type { SendTestSmsMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const sendTestSms = async ({ phoneNumber, content, type }: SendTestSmsMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
      content,
      type,
    },
    mutation: graphql(`
      mutation SendTestSms($phoneNumber: String!, $content: String!, $type: String) {
        sendTestSms(phoneNumber: $phoneNumber, content: $content, type: $type)
      }
    `),
  });

  return response.data?.sendTestSms ?? false;
};
